/*
 *
 * PatientDataPage reducer
 *
 */

import {fromJS} from "immutable";
import {
  CLOSE_MESSAGE_SUCCESS,
  CLOSE_PRODUCTPLAN,
  CLOSE_PRODUCTPLAN_FAILED,
  CLOSE_PRODUCTPLAN_SUCCESS,
  CLOSE_TREATMENTPLAN,
  CLOSE_TREATMENTPLAN_FAILED,
  CLOSE_TREATMENTPLAN_SUCCESS,
  DEFAULT_ACTION,
  DELETE_PATIENT,
  DELETE_PATIENT_FAILED,
  DELETE_PATIENT_SUCCESS,
  GET_ACTIVE_PRODUCT_PLAN,
  GET_ACTIVE_PRODUCT_PLAN_FAILED,
  GET_ACTIVE_PRODUCT_PLAN_SUCCESS,
  GET_MESSAGE_DETAILS,
  GET_MESSAGE_DETAILS_ERROR,
  GET_MESSAGE_DETAILS_SUCCESS,
  GET_MESSAGES_SUCCESS,
  GET_PATIENT,
  GET_PATIENT_FAILED,
  GET_PATIENT_SUCCESS,
  GET_PLANNED_TREATMENTS,
  GET_PLANNED_TREATMENTS_FAILED,
  GET_PLANNED_TREATMENTS_SUCCESS,
  GET_TREATMENT_HISTORY,
  GET_TREATMENT_HISTORY_FAILED,
  GET_TREATMENT_HISTORY_SUCCESS,
  RESET_DELETE_PATIENT_ERROR_MESSAGE,
  RESET_ORDER_REMAKE_REQUEST,
  RESET_SEND_TREATMENT_REFITTING_REQUEST,
  SEND_ORDER_REMAKE_REQUEST,
  SEND_ORDER_REMAKE_REQUEST_ERROR,
  SEND_ORDER_REMAKE_REQUEST_SUCCESS,
  SEND_TREATMENT_REFITTING_REQUEST,
  SEND_TREATMENT_REFITTING_REQUEST_ERROR,
  SEND_TREATMENT_REFITTING_REQUEST_SUCCESS,
  SET_CURRENT_PAGE,
  SOFT_RESET,
  UPDATE_PATIENT,
  UPDATE_PATIENT_FAILED,
  UPDATE_PATIENT_SUCCESS,
} from "./constants";

export const initialState = fromJS({
  patient: null,
  patientLoading: false,

  patientUpdateFailed: null,
  patientUpdateLoading: false,

  plannedTreatments: null,
  plannedTreatmentsLoading: false,

  treatmentHistory: [],
  treatmentHistoryLoading: false,

  closeTreatmentPlanLoading: false,

  deletePatientLoading: false,
  deleted: false,
  deleteFailed: null,

  messageDetailLoading: false,
  messageDetail: {},

  remakeRequestLoading: false,
  remakeProductOrder: null,

  refittingTreatmentLoading: false,
  refittingPlannedTreatment: {},

  messages: [],
  total: 0,
  currentPage: 0,
  statusOpenCount: 0,
  productPlan:{},
  productPlanLoading: false,
});

function patientDataPageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_PAGE:
      return state.set("currentPage", action.page);

    case CLOSE_MESSAGE_SUCCESS:
      return state.set("messageDetail", action.data);

    case GET_MESSAGES_SUCCESS:
      return state
        .set("messages", fromJS(action.data.list))
        .set("total", action.data.total)
        .set("statusOpenCount", action.data.statusOpenCount);
    case GET_MESSAGE_DETAILS:
      return state.set("messageDetailLoading", true).set("messageDetail", {});
    case GET_MESSAGE_DETAILS_SUCCESS:
      return state
        .set("messageDetailLoading", false)
        .set("messageDetail", action.data);
    case GET_MESSAGE_DETAILS_ERROR:
      return state.set("messageDetailLoading", false).set("messageDetail", {});

    /**
     * Get patient
     */
    case GET_PATIENT:
      return state.set("patient", null).set("patientLoading", true);
    case GET_PATIENT_FAILED:
      return state.set("patient", null).set("patientLoading", false);
    case GET_PATIENT_SUCCESS:
      return state.set("patient", action.result).set("patientLoading", false);

    /**
     * Update patient
     */
    case UPDATE_PATIENT:
      return state
        .set("patientUpdateFailed", null)
        .set("patientUpdateLoading", true);
    case UPDATE_PATIENT_FAILED:
      return state
        .set("patientUpdateFailed", action.reason)
        .set("patientUpdateLoading", false);
    case UPDATE_PATIENT_SUCCESS:
      return state
        .set("patientUpdateFailed", null)
        .set("patientUpdateLoading", false)
        .set("patient", action.result);

    /**
     * Get planned treatments
     */
    case GET_PLANNED_TREATMENTS:
      return state
        .set("plannedTreatments", null)
        .set("plannedTreatmentsLoading", true);
    case GET_PLANNED_TREATMENTS_FAILED:
      return state
        .set("plannedTreatments", null)
        .set("plannedTreatmentsLoading", false);
    case GET_PLANNED_TREATMENTS_SUCCESS:
      return state
        .set("plannedTreatments", action.result)
        .set("plannedTreatmentsLoading", false);

    /**
     * Get planned treatments
     */
    case GET_ACTIVE_PRODUCT_PLAN:
      return state
        .set("productPlan", null)
        .set("productPlanLoading", true);
    case GET_ACTIVE_PRODUCT_PLAN_FAILED:
      return state
        .set("productPlan", null)
        .set("productPlanLoading", false);
    case GET_ACTIVE_PRODUCT_PLAN_SUCCESS:
      return state
        .set("productPlan", action.result)
        .set("productPlanLoading", false);

    /**
     * Close TreatmentPlan
     */
    case CLOSE_TREATMENTPLAN:
      return state.set("closeTreatmentPlanLoading", true);
    case CLOSE_TREATMENTPLAN_SUCCESS:
      return state
        .set("closeTreatmentPlanLoading", false)
        .set("plannedTreatments", null);
    case CLOSE_TREATMENTPLAN_FAILED:
      return state.set("closeTreatmentPlanLoading", false);

    /**
     * Close TreatmentPlan
     */
    case CLOSE_PRODUCTPLAN:
      return state.set("closeProductPlanLoading", true);
    case CLOSE_PRODUCTPLAN_SUCCESS:
      return state
        .set("closeProductPlanLoading", false)
        .set("productPlan", null);
    case CLOSE_PRODUCTPLAN_FAILED:
      return state.set("closeProductPlanLoading", false);

    /**
     * Get treatment history
     */
    case GET_TREATMENT_HISTORY:
      return state
        .set("treatmentHistory", fromJS([]))
        .set("treatmentHistoryLoading", true);
    case GET_TREATMENT_HISTORY_FAILED:
      return state
        .set("treatmentHistory", fromJS([]))
        .set("treatmentHistoryLoading", false);
    case GET_TREATMENT_HISTORY_SUCCESS:
      return state
        .set("treatmentHistory", fromJS(action.result))
        .set("treatmentHistoryLoading", false);

    /**
     * Reset
     */
    case SOFT_RESET:
      return initialState
        .set("patient", state.get("patient"))
        .set("deleteFailed", "");

    /**
     * Delete patient
     */
    case DELETE_PATIENT:
      return state.set("deletePatientLoading", true);
    case DELETE_PATIENT_FAILED:
      return state
        .set("deletePatientLoading", false)
        .set("deleteFailed", action.reason.message);
    case DELETE_PATIENT_SUCCESS: {
      return state
        .set("patient", null)
        .set("deleted", true)
        .set("deletePatientLoading", false);
    }
    case RESET_DELETE_PATIENT_ERROR_MESSAGE:
      return state.set("deleteFailed", "");

    /**
     * Send remake request
     */
    case SEND_ORDER_REMAKE_REQUEST:
      return state.set("remakeRequestLoading", true);
    case SEND_ORDER_REMAKE_REQUEST_ERROR:
      return state.set("remakeRequestLoading", false);
    case SEND_ORDER_REMAKE_REQUEST_SUCCESS: {
      return state
        .set("remakeRequestLoading", false)
        .set("remakeProductOrder", action.data);
    }
    case RESET_ORDER_REMAKE_REQUEST:
      return state.set("remakeProductOrder", null);

    /**
     * Send treatment refitting request
     */
    case SEND_TREATMENT_REFITTING_REQUEST:
      return state.set("refittingTreatmentLoading", true).set("refittingPlannedTreatment", {});
    case SEND_TREATMENT_REFITTING_REQUEST_ERROR:
      return state.set("refittingTreatmentLoading", false);
    case SEND_TREATMENT_REFITTING_REQUEST_SUCCESS: {
      return state
        .set("refittingTreatmentLoading", false)
        .set("refittingPlannedTreatment", action.data);
    }
    case RESET_SEND_TREATMENT_REFITTING_REQUEST:
      return state.set("refittingPlannedTreatment", null);


    /**
     * Other
     */
    case DEFAULT_ACTION:
      return state;
    default:
      return state;
  }
}

export default patientDataPageReducer;
